import React from 'react';
import {Modal,Button} from 'react-bootstrap';
import Icon from '../Icons/Icon';
import OrderHistory from './OrderHistory/OrderHistoryContainer';
import PersonalInfo from './PersonalInfo/PersonalInfoContainer';
import MyAddresses from 'ViewModels/Components/MyAccount/MyAddresses/MyAddressesContainer';
import MyParties from './HostPortal/MyPartyListContainer';
import auth from 'auth'; 
import Tac from './../../Components/Login/TermAndConditions';
import LoginActions from './../Login/LoginActions';
import LoginStore from '../Login/LoginStore';
export default class MyAccount extends React.Component {
	constructor(props) {

		super(props);
		this.onChange = this.onChange.bind(this);
		this.SaveTac = this.SaveTac.bind(this);
		this.state = LoginStore.getState();
	
		if (!auth.loggedIn()) {
			window.location = window.jenkon.consultantRoot + "login?redirectUrl=" + window.location;
		}
	}
	componentDidMount() {
		
		LoginStore.listen(this.onChange);
		
		LoginActions.isTaCFeatureActive( window.jenkon.country);
		
		LoginActions.GetTac(window.jenkon.country);
		LoginActions.isTacAccepted();

    }
	onChange(state) {
		this.setState(state);
	
	}
	
	isTacChecked(){
		
		if(this.state.TacCheckbox)
		return true;
		else
		return false;
	}
SaveTac(){
	
		LoginActions.saveTac();
		this.setState({
			isTacAccepted :true
		});
	

}
	componentWillMount() {	
		
		if (this.props.initialTab) {
			switch (this.props.initialTab.toLowerCase()) {
				case 'myaddresses':
					this.props.setView(MyAddresses);
					break;
				case 'personalinfo':
					this.props.setView(PersonalInfo);
					break;
				default:
					break;
			}
		}
	

	}


	render(){
let Rules ={
	TacChecked :{
		required: true,
		requiredMessage :this.props.resources['PWS.CreateAccountForm.checkTacNeed']
	}
}
		
		let TacnotAccepted= this.state.TacActive ? !this.state.isTacAccepted?
	
		<Modal.Dialog>
		<Modal.Header>
		  <Modal.Title>{this.props.resources['PWS.MyAccount.ModalTitle']}</Modal.Title>
		</Modal.Header>
	  
		<Modal.Body>
		  <p> {this.props.resources['PWS.MyAccount.ModalMessage']}</p>
			<Tac
				Rules={Rules}
				TacText={this.state.TaCText}
				TacUrl ={this.state.TaCUrl}
				value ={this.state.TacCheckbox?this.state.TacCheckbox:''}
					/> 
					
		</Modal.Body>
	  
		<Modal.Footer>
		
		  <Button onClick={this.SaveTac} disabled={!this.state.TacCheckbox}>{this.props.resources['PWS.MyAccount.ModalSaveButton']}</Button>
		</Modal.Footer>
	  </Modal.Dialog>:'':'';
	 
		let Icons = {
			clipboard: {
				Fill: '#333',
				name: 'Clipboard',
				Size: 48
			},
			location: {
				Fill: '#333',
				name: 'Location',
				Size: 48
			},
			info: {
				Fill: '#333',
				name: 'Info',
				Size: 48
			},
			heart: {
				Fill: '#333',
				name: 'Heart',
				Size: 48
			},
			calendar: {
				Fill: '#333',
				name: 'Calendar',
				Size: 48
			}
	
		}

		return(
			
			<div className="icons-button-section animate-in">
				<div className="blurb text-center">
					<div className="title">{this.props.resources["PWS.MyAccount.MyAccountTitle"]}</div>
					<div className="description">{this.props.resources["PWS.MyAccount.MyAccountPageDescription"]}</div>
				<div style={ this.state.TacActive ? !this.state.isTacAccepted? {display: 'block' }: { display: 'none' }:{display:'none'}}>
				{ TacnotAccepted}
					</div>	
				</div>
				<ul className="buttons-group">
					<li className="anim-zoomXXX">
						<button className="big-button svg-image style03 hover-style01" onClick={this.props.setView.bind(this, OrderHistory)}>
							<div className="account-section-icons orders">
								<Icon iconData={Icons.clipboard} />
								<span className="visuallyhidden">{this.props.resources["PWS.MyAccount.OrderHistorySectionLabel"]}</span>
							</div>
							<span className="big-button-text">{this.props.resources["PWS.MyAccount.OrderHistorySectionLabel"]}</span>
						</button>
					</li>
					<li className="anim-zoomXXX">
						<button className="big-button svg-image style03 hover-style01" data-section="addresses" onClick={this.props.setView.bind(this, MyAddresses)}>
							<div className="account-section-icons addresses">
								<Icon iconData={Icons.location} />
								<span className="visuallyhidden">{this.props.resources["PWS.MyAccount.AddressesSectionLabel"]}</span>
							</div>
							<span className="big-button-text">{this.props.resources["PWS.MyAccount.AddressesSectionLabel"]}</span>
						</button>
					</li>
					<li className="anim-zoomXXX">
						<button className="big-button svg-image style03 hover-style01" data-section="personal-info" onClick={this.props.setView.bind(this, PersonalInfo)}>
							<div className="account-section-icons info">
								<Icon iconData={Icons.info} />
								<span className="visuallyhidden">{this.props.resources["PWS.MyAccount.PersonalInfoSectionLabel"]}</span>
							</div>
							<span className="big-button-text">{this.props.resources["PWS.MyAccount.PersonalInfoSectionLabel"]}</span>
						</button>
					</li>
					{/*<li className="anim-zoom">
						<button className="big-button svg-image style03 hover-style01" data-section="wishlist">
							<div className="account-section-icons wishlist">
								<Icon iconData={Icons.heart} />
								<span className="visuallyhidden">{this.props.resources["PWS.MyAccount.WishlistSectionLabel"]}</span>
							</div>
							<span className="big-button-text" aria-hidden="true">{this.props.resources["PWS.MyAccount.WishlistSectionLabel"]}</span>
						</button>
					</li> */}
					<li className="anim-zoomXXX">
						<button className="big-button svg-image style03 hover-style01" data-section="host-portal" onClick={this.props.setView.bind(this, MyParties)}>
							<div className="account-section-icons wishlist">
								<Icon iconData={Icons.calendar} />
								<span className="visuallyhidden">{this.props.resources["PWS.MyAccount.HostPortalSectionLabel"]}</span>
							</div>
							<span className="big-button-text" aria-hidden="true">{this.props.resources["PWS.MyAccount.HostPortalSectionLabel"]}</span>
						</button>
					</li>
				</ul>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/MyAccount.js